export const DEFAULT_COL_PROPS = {
  cols: 12,
  sm: 4,
  md: 3,
  lg: 2,
};
